import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notification-list-element',
  templateUrl: './notification-list-element.component.html',
  styleUrl: './notification-list-element.component.scss'
})
export class NotificationListElementComponent {
    @Input() notification: Notification = new Notification("","","","");

    constructor(
        private router: Router,
      ) {}

    pressed () :void {
      if(this.notification.path !== "")
      this.router.navigateByUrl(this.notification.path);
    }
}

export class Notification {
  message: string = "";
  path: string = "";
  icon: string = "";
  matIcon: string = "";

  constructor(
        message: string,
        path: string,
        icon: string,
        matIcon: string,
      ) {
        this.message = message;
        this.path = path;
        this.icon = icon;
        this.matIcon = matIcon;
        }
}
